import React, { useEffect } from 'react';
import { Spinner } from "react-bootstrap";
import axios from 'axios';
import { baseUrl } from '../components/BaseUrl';
import Swal from "sweetalert2";

const Logout = () => {

  useEffect(() => {
    localStorage.clear();

      if(localStorage.getItem("codeflare-login-token") === null){
        logout();
      }

  }, []);

  const logout = () => {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const randomString = Math.random().toString(20).substring(2, 14) + Math.random().toString(20).substring(2, 14);
    const deviceID = `${userAgent}-${platform}-${randomString}`;
      // setDisabled(true);
      const userData = {
        platform: deviceID
      };
      axios.post(`${baseUrl}logout.php`, userData).then((response) => {
        if(response.data.message === "Logged out."){
          window.location.replace("/")
        }else{
          Swal.fire({
            title: "Error",
            text: "Error logging out. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
            backdrop: `
            rgba(143, 70, 0, 0.3)
            url("")
            left top
            no-repeat
          `
          });
          window.location.replace("/dashboard")
        }

      });
    };



  return(
    <div className="logout-container">
    <Spinner animation="border" variant="danger" size="lg" />
    </div>
  )
}

export default Logout;
